<script lang="ts" setup>
import AUApi from "@/api";
import { ref, reactive, onMounted } from "vue";
import CommonVCardDialog from "@/components/common/VCardDialog.vue";
import SaldenAntrag from "@/views/PZE/persoenlich/WF/WorkflowSaldenAntrag.vue";
import { getSiteData } from "@/NavigationHelper";
import { Globals } from "@/Globals";

import {
  globalsBezeichnung,
  begriffBezeichnung,
  globalsKennung,
  globalsAic,
  checkBegriff,
} from "@/local";
import { goBack } from "@/NavigationHelper";
let zeitbereichUrlaub: any;
let maxWidth = window.innerWidth;
const siteData = getSiteData();
onMounted(() => {
  if (siteData) {
    if (siteData.zeitbereich) {
      zeitbereichUrlaub = siteData.zeitbereich;
      const d = new Date();
      const datumHeute = new Date(d.setHours(0, 0, 0, 0));
      const bisZeitZone = zeitbereichUrlaub.bis;
      const bis = new Date(bisZeitZone.setHours(0, 0, 0, 0));
      /* liegt das BIS in der Zukunft - dann darf nur bis HEUTE gerechnet werden */
      if (datumHeute.valueOf() < bis.valueOf()) {
        zeitbereichUrlaub.bis = d;
      }
    }
  }
});
</script>
<template>
  <v-sheet max-width="100%" class="pb-2">
    <CommonVCardDialog
      textQuery="Web_Periodensaldo"
      :text="
        globalsBezeichnung(
          Globals.Begriff,
          'Web_aktSaldo',
          'akt. Periodensaldo'
        )
      "
      textKennung="BERECHNUNG_MASS"
      :zeitbereich="siteData?.zeitbereich"
    ></CommonVCardDialog>
    <CommonVCardDialog
      textQuery="ZE_Gesamtsaldo_Neu"
      :text="
        globalsBezeichnung(
          Globals.Begriff,
          'Web_Gesamtsaldo',
          'akt. Gesamtsaldo'
        )
      "
      textKennung="BERECHNUNG_MASS"
      :zeitbereich="siteData?.zeitbereich"
      class="mt-1"
    ></CommonVCardDialog>
    <CommonVCardDialog
      textQuery="ZE_Alle_Anspruche__In__Tagen"
      :text="
        globalsBezeichnung(Globals.Begriff, 'Web_Text_Anspruch', 'Ansprüche')
      "
      textKennung="Tage"
      text1Kennung="Abgearbeitet"
      :text1="globalsBezeichnung(Globals.Begriff, 'Web_Stichtag', 'Stichtag')"
      :zeitbereich="zeitbereichUrlaub"
      class="mt-1"
    ></CommonVCardDialog>

      <SaldenAntrag
        v-if="checkBegriff('ZE_Mitarbeiter_Monatsabschluss')"
        @back="goBack()"
        :zeitbereichUebergabe="siteData?.zeitbereich"
        class="pa-0 pt-1"
      ></SaldenAntrag>

  </v-sheet>
</template>
<style scoped>
.dvhCard {
  padding-left: 5px;
  height: 100px;
}
.dvhCol {
  padding-bottom: 0px;
  padding-right: 0px;
  padding-left: 10px;
}
@media (max-width: 550px) {
  .v-card__subtitle,
  .v-card__text,
  .v-card__title {
    padding: 10px;
  }
}
</style>
